import LastResult from "../components/utils/LastResult.vue";
import VueContext from 'vue-context';
import 'vue-context/dist/css/vue-context.css';
import {
    prettyBytes,
    secondsToFormattedString,
    diffDate,
    fromNow,
    getValueOrDefault,
    insertSpacesEveryThreeDigits,
    assignProperties,
    clearObject,
    waitSeconds,
    getMapWithCategoriesAndPlatformTypes,
    cookieManager,
    exportListInCSVFile,
} from "../utils/utilitiesmodule";
import NoDataAvailable from "../components/utils/NoDataAvailable";
import UpgradeToUnlockFeature from "../components/utils/UpgradeToUnlockFeature";
import TruncatedText from "../components/utils/TruncatedText";
import Navigation from "../components/utils/Navigation";
import mBadge from "../components/utils/mBadge";
import vueContext from 'vue-context/src/js/vue-context';
import { ClientTreeNode } from '../models/TreeNode';
import PCBackupLink from '../components/utils/PCBackupLink.vue';
import StatsCollector from '../components/stats/StatsCollector.vue'
import { BACKUP_MESSAGES, PC_MESSAGES } from '../utils/messages';
import WebRTCSession from '../services/WebRTCSession';
import NoConnection from "../components/utils/NoConnection.vue";
import { iconsToModuleEnabled, iconsToModuleDisabled } from "../utils/objects.js";
import NetworkScan from "../components/panels/NetworkScan.vue";
import SoftwareInventory from "../components/panels/SoftwareInventory.vue";
import TaskManager from "../components/panels/TaskManager.vue";
import EventLogs from "../components/panels/EventLogs.vue";
import FileExplorer from "../components/panels/FileExplorer.vue";

export default {
    components: {
        LastResult,
        LastResult,
        NoDataAvailable,
        UpgradeToUnlockFeature,
        NoConnection,
        TruncatedText,
        Navigation,
        VueContext,
        mBadge,
        vueContext,
        "PCBackupLink": PCBackupLink,
        StatsCollector,
        SoftwareInventory,
        NetworkScan,
        TaskManager,
        EventLogs,
        FileExplorer
    },
    name: "Computer",
    metaInfo: {
        // if no subcomponents specify a metaInfo.title, this title will be used
        title: 'Computer',
        // all titles will be injected into this template
        titleTemplate: '%s | Iperius ONE',
    },
    watch: {
        '$route': {
            handler: function (to) {
                //Si vuole terminare un processo
                if (to.hash != "" && to.hash.startsWith("#killprocess_")) {
                    var pid = to.hash.replace("#killprocess_", "");
                    this.killApp(pid);
                    return;
                }

                if (to.hash != "" && to.hash.startsWith("#installpatch_")) {
                    var idPatch = to.hash.replace("#installpatch_", "");
                    this.sendInstallMessage(idPatch);
                    return;
                }

            },
            deep: true,
            immediate: true
        }
    },
    data() {
        return {
            remoteSessionActive: false,
            remoteControlSession: null,
            onlyremoteinstalled: true,
            tabOpened: 1,
            activePanel: 'sysinfo',
            connectionState: 'disconnected',
            notificationsList: {},
            computerKey: 0,

            remote: {
                id: "",
                pw: "",
                webSocket: null,
                peerConnection: null,
                dataChannel: null,
                remoteStream: null,
                localCanvas: null,
            },

            loading: false,
            // [TG - apertura restore da menu sx singolo job]
            restoreType: -1,
            selectedJobId: "",
            settings_opened: false,
            serviceAccount: null,
            selectedGroups: [],
            repository: null,
            is_global_running: {
                jobs: false,
                patches: false,
                restores: false,
            },

            // PANNELLO PRINCIPALE
            pc: null,
            hasCustomPassword: false,
            originalCustomPassword: "",
            originalCustomSettingsSnapshot: null,
            LicenseGroups: null,
            fullStats: null,
            patches: null,
            patchInstalled: "",
            policiesList: [],
            jobPoliciesList: [],
            api_backups: null,
            socket_backups: null,
            restores: [], // socket [GT - 06/06/2023]
            cronstrue: null,
            cronParser: null,
            latest_version_one: '',
            last_release_date: null,
            needed_update: false,

            //PANNELLO DX
            system: { // socket realtime
                CPU: 0,
                usedRAM: 0,
                availableRAM: 0,
                totalRAM: 0,
                readDiskspeed: 0,
                writeDiskspeed: 0,
                diskTransfers: 0,
                agentVersion: '',
                isUpdating: false,
                updateProgressStatus: {
                    Current_operation: 'Downloading...',
                    Current_version: '',
                    Dt_end_utc: '',
                    Dt_start_utc: '',
                    New_version: '',
                    Progress: {
                        BytesReceived: 0,
                        ProgressPercentage: 0,
                        TotalBytesToReceive: 0
                    },
                    lastresult: 3
                },

            },
            disks: null, //socket






            //PANNELLO DINAMICO LOGS
            backupJobLogs: null,

            //Recuperati tramite API
            selectedgroup: null,
            windowWidth: 0,
            openAfterRefresh: false,
            selectedIndex: -1,
            log_visible: false,

            runAppPath: "",
            antivirusString: '',

            backupJobs_filters: {
                sourceTypesList: getMapWithCategoriesAndPlatformTypes("forBackupSource", true),
                sourceType: -1,
                destinationTypesList: getMapWithCategoriesAndPlatformTypes("forBackupDestination", true),
                destinationType: -1,
                resultList: this.$ResultValue,
                lastresult: -1,
                withNotification: -1,
                orderByFunction: this.$OrderBy.DATE_DESC.apply,
                values: [
                    //this.$OrderBy.UNSPECIFIED,
                    this.$OrderBy.NAME_ASC,
                    this.$OrderBy.NAME_DESC,
                    this.$OrderBy.DATE_ASC,
                    this.$OrderBy.DATE_DESC,
                ]
            },

            patches_filters: {
                status: -1,
                orderByFunction: this.$OrderBy.NOT_INSTALLED_INSTALLED.apply,
                values: [
                    //this.$OrderBy.UNSPECIFIED,
                    this.$OrderBy.SEVERITY_ASC,
                    this.$OrderBy.SEVERITY_DESC,
                    this.$OrderBy.INSTALLED_NOT_INSTALLED,
                    this.$OrderBy.NOT_INSTALLED_INSTALLED,
                    this.$OrderBy.LAST_UPDATE_ASC,
                    this.$OrderBy.LAST_UPDATE_DESC,
                ]
            },

            //TODO Prendere quelli di giancarlo
            id: "",
            backupIDForView: null,
            dataRetrieved: false,



            jobIDsOrder: [], //Conterrà gli id dei job in ordine in base ai parametri stabiliti nell'agent (attualmente sono ordine in base all'ultimo avvio)

            running_backups: [],
            running_restores: [],
            licenses: {},
            licensesList: [],

            hasCheckedVersion: false,
            isDeleting: false,
            isInAddressBook: true,


        }
    },
    props: {
        idPC: String,
    },
    computed: {

        hasSystemInfo() {
            return !!this.pc && !!this.pc.system_info &&
                typeof this.pc.system_info === "object" &&
                Object.keys(this.pc.system_info).length > 0;
        },

        canSaveCustomPassword() {
            const password = this.pc.custom_password || "";
            const repeatedPassword = this.pc.custom_password2 || "";
            return password !== "" &&
                password === repeatedPassword &&
                password !== this.originalCustomPassword;
        },

        hasCustomSettingsChanges() {
            return !!this.pc && this.originalCustomSettingsSnapshot !== null &&
                this.customSettingsSnapshot(this.pc) !== this.originalCustomSettingsSnapshot;
        },

    },

    beforeDestroy: async function () {
        this.pc = null; // Pulizia dei dati
        this.backupJobLogs = null;
        this.job = null;
        this.api_backups = [];
        clearObject(this.$root.remote_map_idPC_idRemote);
        this.$root.checkRemoteConnectionTimerLight();
        this.$root.$off("roomPCConnectionStatus");
        this.$root.$off("socketEventConnected");
        this.$root.$off("socketEventDisconnected");
        this.$root.$off("addRealTimeSystemDataToPage");
        this.$root.$off("addWUToPage");
        this.$root.$off("addRestoreToPage");
        this.$root.$off("realtimeEvents");
        this.$root.$off("cancel");
        this.$root.$off("DeletedJob");

        this.$root.$off("refreshPolicies");
        this.$session.set("REALTIMEJOBS", []);
    },
    created: function () {
        this.LicenseGroups = this.$session.getGroups();
    },

    mounted: async function () {


        //this.$root.newPage("computer", "mounted");
        /*  if (!this.$root.loadPage("computer"))
        return; */
        let self = this;

        self.cronstrue = require('cronstrue/i18n');
        self.cronParser = require('cron-parser');

        await self.loadLicensesList();

        //Step 1 : Richiedo i dati per il pannello principale con le chiamate API
        await self.loadComputer();

        waitSeconds(1).then(() => {
            if (self.$route?.hash) {
                self.$nextTick(() => {
                    const panel = self.$route.hash.replace('#', '');
                    self.selectPanel(panel);
                    self.$router.removeHash();
                });
            }

        });
        self.$root.$on("SETPAGEPROP", (prop, data) => {

            if (prop == "socket_backups") {

                if (self[prop] == null) {
                    self[prop] = data;
                } else {
                    assignProperties(data, self[prop], false);
                }
            }

            if (prop == "running_backups" || prop == "running_restores") {
                if (self[prop] == null) {
                    self[prop] = data;
                } else {
                    self[prop].update(data)
                }
            }
        });


        /**
         *  0 -> # computer ancora senza licenza one, ma in rubrica di Iperius Remote
         *  1 -> # computer connesso tuttora alla licenza corretta;
         *  2 -> # computer in stato di waiting solo con questa licenza: si può ricollegare;
         *  3 -> # computer rimosso da questa licenza: NON si potrà ricollegare fino a riabilitazione;
         *  4 -> # computer BANNATO: non si potrà mai più ricollegare fino a nostro contrordine;
         *  */
        //self.$session.setRoomPC(self.pc);
        //self.$root.startToListenPC(this.idPC);
        this.$root.$on("refreshPolicies", () => self.refreshPolicies());

        this.$api.getNotifications().then((notificationjobs) => {
            self.notificationsList = notificationjobs;
        });

        // nel caso sia installato iperiusone
        if (!self.onlyremoteinstalled) {

            /*  if (self.pc != null && self.pc.security_status) {
                 self.antivirusString = self.pc.security_status.antivirusList.map(x => x.name + "(" + (x.enabled ? "enabled" : "not enabled") + ")").join(", ");
             } */

            this.$api.getJobPoliciesList(self.idPC).then((list) => {
                self.jobPoliciesList = list;
            });

            this.$api.getPCPoliciesList(self.idPC).then((list) => {
                self.policiesList = list;
            });

            //###DA INSERIRE IN OGNI COMPONENTE CHE NECESSITA DI CHIAMATE SOCKET###
            // "checkSocket" avvia la connessione socket se ferma
            // "socketEventConnected" viene emesso quando la connessione socket è attiva, quindi nella sua callback si possono avviare tutte le istruzioni che riguardano le chiamate socket
            // "socketEventDisconnected" viene emesso quando la connessione socket non è attiva
            this.$root.$on("socketEventConnected", () => {
                //self.retrieveDataFromSocket();
            });
            //"socketEventDisconnected" viene emesso se la connessione socket non è attiva
            this.$root.$on("socketEventDisconnected", () => {
            });

            this.$root.$on("roomPCConnectionStatus", isConnected => {
                if (isConnected) {
                    self.retrieveDataFromSocket();
                    self.hasCheckedVersion = false;
                }
            });

            //this.$root.checkSocket();

            //####################################################################

            //UTILITIES
            this.$root.$on("cancel", () => this.reset());
            this.$root.$on("DeletedJob", idBackup => {
                //Documentazione : https://www.w3schools.com/howto/howto_js_remove_property_object.asp
                delete self.socket_backups[idBackup];
            });

            // ----------------------------------------------------------------------------

            //INIZIO DELLE CALLBACKS PER LA CONNESSIONE SOCKET


            this.$root.$on("addIDsOrder", idsOrder => {
                self.jobIDsOrder = idsOrder;
            })

            this.$root.$on("addWUToPage", wu_received => {
                if (wu_received == null) {
                    self.patches = null;
                } else if (self.patches == null) {
                    self.patches = Object.fromEntries(
                        Object.entries(wu_received)
                            .sort(([, valA], [, valB]) => new Date(valB.lastDeploymentChangeTime) - new Date(valA.lastDeploymentChangeTime))
                    )/*wu_received*/;
                } else {
                    for (let [key, value] of Object.entries(wu_received)) {
                        self.patches[key] = value;
                    }
                }
            });







            // da completare per valorizzare lista restore in corso cu computer.js
            this.$root.$on("addRestoreToPage", async restores => {
                if (self.restores == null) {
                    self.restores = restores;
                } else {
                    for (let [id, job] of Object.entries(restores)) {
                        self.restores[id] = job;
                    }
                }
            });

            this.$root.$on("realtimeEvents", event => {
                var mss = event.split("|");
                this.$root.toast(this.$t(mss[0]), mss[1]);
            });






            this.$root.$on("addRealTimeSystemDataToPage", rt_systemData => {
                self.addRealTimeSystemDataToPage_Callback(rt_systemData);

                if (!self.hasCheckedVersion) { // self.hasCheckedVersion viene reimpostato a false quando il pc si riconnette al socket (evento roomPCConnectionStatus)
                    self.hasCheckedVersion = true;
                    self.checkLatestVersionAndAllowUpdate();
                }

            });



        }
    },

    filters: {
        prettyBytes: function (bytes, precision) {
            return prettyBytes(bytes, precision);
        },
    },

    methods: {
        async loadLicensesList() {
            let allLicenses = this.$session.getLicenses();
            const hasLicenses = Array.isArray(allLicenses)
                ? allLicenses.length > 0
                : allLicenses && Object.values(allLicenses).some(value => Array.isArray(value) && value.length > 0);

            if (!hasLicenses) {
                allLicenses = await this.$api.getLicenses();
            }

            const licenses = Array.isArray(allLicenses)
                ? allLicenses
                : [
                    ...(allLicenses?.backup || []),
                    ...(allLicenses?.monitoring || [])
                ];

            this.licensesList.update(licenses.map(license => {
                const computerIds = new Set(license.computers?.map(computer => computer.id) || []);

                return {
                    id: license.id,
                    description: license.description,
                    used_slots: license.used_slots,
                    total_slots: license.total_slots,
                    computerId: computerIds.has(this.idPC) ? this.idPC : ''
                };
            }));
        },

        async loadComputer() {
            const pc = await this.$api.getPC(this.idPC);

            pc.groups = (pc.groups || []).map(group => group.id);
            this.hasCustomPassword = pc.is_protected == 1 && ![null, ''].includes(pc.custom_password);
            this.originalCustomPassword = pc.custom_password || "";
            if (pc.is_protected) {
                pc.custom_password2 = pc.custom_password;
            }

            this.onlyremoteinstalled = pc.backup_license_status == 0;
            this.pc = pc;
            this.originalCustomSettingsSnapshot = this.customSettingsSnapshot(pc);
        },

        customSettingsSnapshot(pc) {
            return JSON.stringify({
                groups: (pc.groups || []).map(String).sort(),
                name: pc.name || "",
                organization_name: pc.organization_name || "",
                description: pc.description || ""
            });
        },

        isActivePanel(panel) {
            return this.activePanel == panel;
        },

        panelButtonClass(panel) {
            return this.isActivePanel(panel) ? 'computer-panel-tab-active' : 'computer-panel-tab';
        },

        selectPanel(panel) {
            const panels = [
                'sysinfo',
                'backups',
                'restores',
                'taskmanager',
                'fileexplorer',
                'eventlogs',
                'patches',
                'softwareinventory',
                'networkscan',
            ];

            if (!panels.includes(panel)) {
                return;
            }

            this.activePanel = panel;

            this.$nextTick(() => {
                requestAnimationFrame(() => {
                    setTimeout(() => this.runPanelOpenAction(panel), 0);
                });
            });
        },

        runPanelOpenAction(panel) {
            switch (panel) {
                case 'taskmanager':
                    this.$refs.taskManager?.startRetrieveProcessList();
                    break;
                case 'fileexplorer':
                    this.$refs.fileExplorer?.getFileSystem();
                    break;
                case 'eventlogs':
                    this.$refs.eventLogs?.getEventLogs(false);
                    break;
                case 'softwareinventory':
                    this.$refs.softwareInventory?.getSWList(false);
                    break;
                case 'networkscan':
                    this.$refs.networkScan?.startNetworkScan(false);
                    break;
            }
        },

        async checkLatestVersionAndAllowUpdate() {

            let self = this;
            self.needed_update = false;
            try {

                // [GT - 06/06/2025] lettura di eventuale aggiornamento di iperiusone e gestione comparsa indicazione e bottone per update    
                const osArch = this.pc.system_info?.[this.$SystemInfoType.OS_ARCHITECTURE]?.info_value;
                const string_version = await this.$api.getLatestOneVersion(osArch, false);

                if (string_version) {
                    const { major, minor, release, build } = string_version;
                    const { date_of_release } = string_version;
                    self.latest_version_one = `${major}.${minor}.${release}.${build}`;
                    self.last_release_date = `${date_of_release}`;
                    const installed_version_one = this.system.agentVersion;

                    if (this.compareVersions(this.latest_version_one, installed_version_one) > 0) {
                        console.log('È disponibile una nuova versione di Iperius One!');
                        self.needed_update = true;
                    } else {
                        console.log('Sei già aggiornato.');
                    }
                }

            } catch (error) {
                console.writeError('Impossibile recuperare i dati della versione: ', error);
            }
        },

        openStartDialogDelete() {

            const self = this;
            const dialogID = Math.floor(100000 + Math.random() * 900000).toString();

            // ID univoco per la checkbox, così non collide con altri dialog
            const checkboxId = `rmOneGroups_${dialogID}`;

            // Contenuto base
            let content = `
            <div class="mb-3 ml-1 d-flex flex-align-center">                
                ${this.$t('Are you sure you want to remove this Iperius Remote client from the address book associated with your license?')}
            </div>
        `;

            // (Opzionale) testo aggiuntivo se onlyremoteinstalled
            /*if (!self.onlyremoteinstalled) {
                content += `
                <div class="mb-3 ml-1">
                    ${this.$t('This computer is also in the groups for the Iperius One license. Do you want to remove it from these groups as well ?')}
                </div>
                `;
    
                content += `
                        <div class="mb-2 ml-1">
                            <label class="checkbox">
                                <input type="checkbox" id="${checkboxId}">
                                <span class="check"></span>
                                <span class="caption">${this.$t('Remove from Iperius One groups')}</span>
                            </label>
                        </div>
                    `;
    
            }*/

            // Handler del dialog (OK/Cancel)
            this.$root.$on(dialogID, async ok => {
                try {
                    if (!ok) return;

                    // Leggo lo stato della checkbox
                    //const cb = document.getElementById(checkboxId);
                    //const removeFromOneGroups = !!(cb && cb.checked);

                    const removeFromOneGroups = false;

                    // CHIAMATA API / azione di delete — passa il flag
                    self.$api.deleteComputerFromAddressBook(self.idPC, removeFromOneGroups).then((res) => {
                        if (res != null) {
                            self.pc.remote_license_status = 0;
                            if (removeFromOneGroups) {
                                this.pc.groups = [];
                                this.$router.go(0);
                            }
                            self.$root.toast(this.$t(PC_MESSAGES.REMOVE_FROM_ADDRESSBOOK), "success");
                        }
                    });

                } finally {
                    this.$root.$off(dialogID);
                }
            });

            const title = `
                        <div class="d-flex flex-align-center">
                            <svg width="32" height="32" viewBox="0 0 24 24"
                                class="mr-2 mt-2"
                                style="vertical-align:bottom; flex-shrink:0;"
                                aria-hidden="true">
                            <path fill="#001affff"
                                    d="M10 1.5c-.33 0-.64.17-.82.45l-8 13A.94.94 0 0 0 1.94 16h16.12a.94.94 0 0 0 .76-1.05l-8-13A.95.95 0 0 0 10 1.5zM10 6c.28 0 .5.22.5.5v4a.5.5 0 0 1-1 0v-4c0-.28.22-.5.5-.5zm0 7a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5z"/>
                            </svg>
                            <span class="ml-1 m-0">` + this.$t("Confirm deletion from address book") + `</span>
                        </div>`;

            this.$root.openYesNoDialog(dialogID, title, content, this.$t("Delete"), this.$t("Close"), "js-dialog-close secondary", "js-dialog-close button");

        },

        openStartDialogUpdate() {

            let self = this;
            let go = true;

            let dialogID = Math.floor(100000 + Math.random() * 900000).toString();

            let content = `<div class="mb-3 ml-1">${this.$t('A new version of Iperius One is now available!')}</div>`;
            content += `<div class="mb-3 ml-1">${this.$t('This update {0} was released on {1}', { 0: self.latest_version_one, 1: self.last_release_date.toLocalDate() })}</div>`;
            //this.$t('This update {0} was released on {1} ', { 0: self.latest_version_one, 1:  self.last_release_date.toLocalDate()});

            // controlli e dati
            // 1. la versione a cui si aggiornare
            // 2. in futuro eventuale change log
            // 3. controllo e nomi di eventuali backup o restore in esecuzione e indicare di stopparli

            go = (this.running_backups.length > 0 || this.running_restores.length > 0);

            if (go) {
                content += `<div class="mb-3 ml-1 fg-red"><span class="mif-warning mif-2x mr-2"></span>${this.$t('Warning: backup/restore operations are in progress. Please wait or stop them before continuing.')}</div>`;


                if (this.running_backups.length > 0) {

                    content += "<br>";
                    content += this.$t("Backup Jobs");
                    content += "<ul class='ml-1'>";
                    this.running_backups.forEach(item => {
                        content += `<li>${item.name}</li>`;
                    });
                    content += "</ul>";
                }

                if (this.running_restores.length > 0) {
                    content += "<br>";
                    content += this.$t("Restore Jobs");
                    content += "<ul class='ml-1'>";
                    this.running_restores.forEach(item => {
                        content += `<li>${item.name}</li>`;
                    });
                    content += "</ul>";
                }

                this.$root.$on(dialogID, async ok => {
                    try {
                        if (!ok) {
                            return;
                        }

                    } finally {
                        self.$root.$off(dialogID);
                    }
                    return;
                });

                this.$root.openOnlyOkDialog(dialogID, this.$t("Iperius One Agent Update"), content, this.$t("Close"), "js-dialog-close button");

            } else {
                this.$root.$on(dialogID, async ok => {
                    try {
                        if (!ok) {
                            return;
                        }

                        // CHIAMATA SOCKET PER UPDATE DELL'AGENT ONE
                        self.updateAgent();


                    } finally {
                        self.$root.$off(dialogID);
                    }
                    return;
                });

                this.$root.openYesNoDialog(dialogID, this.$t("Iperius One Agent Update"), content, this.$t("Update"), this.$t("Close"), "js-dialog-close secondary", "js-dialog-close button");

            }

        },

        updateAgent() {
            this.$root.socket("updateagent", this.pc.id);
        },

        compareVersions(v1, v2) {
            const a = v1.split('.').map(Number);
            const b = v2.split('.').map(Number);

            const maxLen = Math.max(a.length, b.length);
            for (let i = 0; i < maxLen; i++) {
                const num1 = a[i] || 0;
                const num2 = b[i] || 0;
                if (num1 > num2) return 1;  // v1 > v2
                if (num1 < num2) return -1; // v1 < v2
            }
            return 0; // equal
        },


        getFeatureIconClass: function (status, feature_id) {

            if (status == 'on') {
                return iconsToModuleEnabled[feature_id] || ''; // fallback icona
            }
            else {
                return iconsToModuleDisabled[feature_id] || ''; // fallback icona
            }
        },

        isComputerInLicense(computerId, license) {
            if (!license.computers) return false;
            //return license.computers.some(comp => comp.id === computerId);

            const computerIds = new Set(license.computers.map(comp => comp.id));
            return computerIds.has(computerId);

        },

        refreshPolicies() {
            let self = this;
            this.$api.getPCPoliciesList(self.idPC).then((list) => {
                self.policiesList = list;
            });
            this.$api.refreshDevicePolicies(self.idPC).then((response) => {
                console.log(response);
            });
        },
        IDRemoteWithSpace(value) {
            return insertSpacesEveryThreeDigits(value);
        },


        reloadComponent() {
            this.componentKey += 1;
        },


        async openDialogPolicy(id_policy) {
            var policy = await this.$api.getPolicy(id_policy);
            this.$root.$emit("OPENPOLICYVIEWDIALOG", policy, this.$session.getPCList());
        },



        handleWebSocketMessage(message) {
            // Handle incoming messages from the WebSocket
            const data = JSON.parse(message.data);
            console.log(data);
        },
        handleRemoteStream(stream) {
            this.remoteVideoElement.srcObject = stream;
        },
        handleConnectionStateChange(state) {
            this.connectionState = state;
        },
        startCall() {
            // Crea un'offerta per iniziare la chiamata
            this.remoteControlSession.createOffer();
        },
        endCall() {
            if (this.remoteControlSession) {
                this.remoteControlSession.closeConnection();
                this.connectionState = 'Disconnected';
                this.remoteVideoElement.srcObject = null;
            }
        },
        async initializeWebRTC() {
            try {
                // Step 1: Create WebRTC session
                this.remoteControlSession = new WebRTCSession(
                    "https://global.iperius-rs.com:443/socket/websocket",
                    this.handleRemoteStream,
                    this.handleConnectionStateChange
                );

                // Step 2: Set up signaling
                await this.setupSignaling();

                // Step 3: Create offer
                await this.remoteControlSession.createOffer();

                // Step 4: Set up mouse and keyboard listeners for remote video control
                this.setupMouseAndKeyboardListeners();
                this.connectionState = 'connected';
            } catch (error) {
                console.writeError('Error initiating remote control:', error);
                this.connectionState = 'disconnected';
            }
        },



        async setupSignaling() {
            // Here you should set up signaling using your server connection, either WebSockets or other signaling protocol
            // Implement the logic to send offers, answers, and ICE candidates between peers
            // These methods replicate the signaling logic found in your connected_controller.dart

            // Example pseudo-code for handling signaling
            this.remoteControlSession.on('icecandidate', (candidate) => {
                this.remoteControlSession.handleIceCandidate(candidate);
            });

            this.remoteControlSession.on('offer', async (offer) => {
                // Send the offer to the signaling server, to be forwarded to the remote peer
                this.remoteControlSession.handleOffer(offer);
            });

            // Add methods for receiving answers and ice candidates from the signaling server
        },

        /*  setupMouseAndKeyboardListeners() {
             const remoteVideo = document.getElementById('remoteVideo');
             if (!remoteVideo) {
                 console.writeError('Remote video element not found');
                 return;
             }

             // Mouse event listeners
             remoteVideo.addEventListener('mousemove', (event) => {
                 this.remoteControlSession.sendMouseData(event.offsetX, event.offsetY);
             });
             remoteVideo.addEventListener('click', (event) => {
                 this.remoteControlSession.sendMouseClickData(event.button);
             });

             // Keyboard event listeners
             window.addEventListener('keydown', (event) => {
                 this.remoteControlSession.sendKeyboardData(event.key, 'keydown');
             });
             window.addEventListener('keyup', (event) => {
                 this.remoteControlSession.sendKeyboardData(event.key, 'keyup');
             });
         }, */

        closeRemoteControlConnection() {
            if (this.remoteControlSession) {
                this.remoteControlSession.closeConnection();
                this.remoteControlSession = null;
                this.connectionState = 'disconnected';
            }
        },

        /***********************PC*********************************************************************************/
        addRealTimeSystemDataToPage_Callback(rt_systemData) {
            this.system = rt_systemData;
            if (rt_systemData.downloadFolderPath) {
                cookieManager.setCookie("downloadFolderPath", rt_systemData.downloadFolderPath);
            }

            if (this.$refs.networkScan) {
                this.$refs.networkScan.status = rt_systemData.networkScanResult;

                if (this.$refs.networkScan.status == this.$ResultValue.Running) {
                    this.$root.websocket.responses["GETNETWORKDEVICES"] != "__WAIT__";
                }
            }

        },

        /***********************************RECUPERO DATI**********************************************************/
        async retrieveDataFromSocket() {
            let self = this;
            this.$root.socket("GetDiskInfo", false, false, false)
                .then(response => {
                    if (response == null) self.disks = [];
                    else self.disks = response.disks;
                });



        },

        convertToCronParserFormat(cronExpression) {
            // Dividi la stringa cron in campi
            const cronParts = cronExpression.split(' ');

            // Se la stringa ha 7 campi, rimuoviamo il primo campo (secondi)
            if (cronParts.length === 7) {
                cronParts.shift(); // Rimuove il campo dei secondi
            }

            // Gestione dei campi non necessari (es: '?', '1/1') e conversione a 5 campi
            return cronParts
                .map((part, index) => {
                    // Rimuove '?' che non è supportato da cron-parser
                    if (part === '?') return '*';

                    // Rimuove '1/1' dai campi mese/giorno del mese
                    if (index >= 2 && (part === '1/1' || part === '1')) return '*';

                    return part;
                })
                .slice(0, 5) // Assicuriamo che ci siano solo 5 campi
                .join(' ');
        },

        nextSched(schedString = "") {
            if (schedString == null || schedString == "") {
                return "";
            }
            var self = this;
            try {
                var compatibleString = this.convertToCronParserFormat(schedString)

                var options = {
                    tz: Intl.DateTimeFormat().resolvedOptions().timeZone
                };

                var interval = this.cronParser.parseExpression(compatibleString, options);

                const nextDate = interval.next().toDate();
                const formattedDate = self.$moment(nextDate).format('LLL'); // Output formattato in base al locale
                return formattedDate;
            } catch (err) {
                console.writeError(err.message);
            }
        },

        async removeFromLicense() {
            var dialogID = Math.floor(100000 + Math.random() * 900000).toString();
            let self = this;
            this.$root.$on(dialogID, async ok => {
                try {
                    if (!ok) {
                        return;
                    }

                    await self.$root.socket("remfromlicense")
                        .then((res) => {
                            self.$root.toast(this.$t(PC_MESSAGES.LICENSE_REMOVED), "success");

                        });
                } finally {
                    self.$router.removeHash(); // prototype implementato in main.js
                    self.$root.$off(dialogID);
                }

            });

            this.$root.openYesNoDialog(dialogID, this.$t("Remove license"), this.$t("Are you sure to remove license?"));
        },

        reconnectToLicense() {
            var dialogID = Math.floor(100000 + Math.random() * 900000).toString();
            let self = this;
            this.$root.$on(dialogID, async ok => {
                try {

                    if (!ok) {
                        return;
                    }
                    await self.$api.addToLicense(self.idPC).then((res) => {
                        if (res != null)
                            self.$root.toast(this.$t(PC_MESSAGES.LICENSE_ADDED), "success");
                    });
                } finally {
                    self.$router.removeHash(); // prototype implementato in main.js
                    self.$root.$off(dialogID);
                }
            });

            this.$root.openYesNoDialog(dialogID, this.$t("Reconnect to license"), this.$t("Are you sure?"));
        },


        toggleNotification(job) {
            var enabled = this.notificationsList[job.id] ? 1 : 0;
            this.$api.setNotification(job.id, !enabled).then((result) => {
                if (result) {
                    enabled ? this.$root.toast(this.$t(BACKUP_MESSAGES.REMOVE_FROM_NOTIFICATIONS), "success") : this.$root.toast(this.$t(BACKUP_MESSAGES.ADD_TO_NOTIFICATIONS), "success");
                    enabled ? this.notificationsList[job.id] = null : this.notificationsList[job.id] = !enabled;
                } else {
                    Object.keys(result).forEach(key => {
                        this.$root.toast(key + ":" + result[key], "alert");
                    });
                }
            });
        },


        /*async editComputer() {

            //this.pc.groups=window.Metro.getPlugin($("#groupselect"), 'select').val();
            //this.pc.groups = (this.pc.groups || []).map(g => g.id);
            var result=await this.$api.editPC(this.pc);
            if (result) {
                this.$root.toast(this.$t(PC_MESSAGES.SAVED), "success");                
            } else {

                Object.keys(result).forEach(key => {

                    this.$root.toast(key+":"+result[key], "alert");
                });
            }

        },*/

        async editComputer() {

            if (!this.hasCustomSettingsChanges) return;

            const self = this;
            const dialogID = Math.floor(100000 + Math.random() * 900000).toString();

            // ID univoco per la checkbox, così non collide con altri dialog
            const checkboxId = `rmOneGroups_${dialogID}`;

            // Contenuto base
            let content = `
            <div class="mb-3 ml-1 d-flex flex-align-center">                
                ${this.$t('Are you sure you want to update the custom settings?')}
            </div>
        `;



            // Handler del dialog (OK/Cancel)
            this.$root.$on(dialogID, async ok => {
                try {
                    if (!ok) return;

                    const result = await this.$api.editPC(this.pc);//ritorna un booleano
                    if (!result) { return; }
                    this.$root.toast(this.$t(PC_MESSAGES.SAVED), "success");
                    await this.loadComputer();
                    var pcLite = this.$session.getPCWithID(this.idPC);
                    pcLite.pc_name = this.pc.name;
                    pcLite.organization_name = this.pc.organization_name;
                    pcLite.description = this.pc.description;
                    this.$session.editPC(this.idPC, pcLite);
                    this.$root.rebuildPcMap();

                } finally {
                    this.$root.$off(dialogID);
                }
            });

            this.$root.openYesNoDialog(dialogID, this.$t("Apply changes to custom settings"), content, this.$t("Apply settings"), this.$t("Close"), "js-dialog-close secondary", "js-dialog-close button");

        },


        saveCustomPw() {
            if (this.pc.custom_password != this.pc.custom_password2) {
                this.$root.toast(this.$t("Passwords are not equals"), "alert");
                return;
            }
            if (this.pc.custom_password == "" || this.pc.custom_password == null) {
                this.$root.toast(this.$t("Passwords are not equals or empty"), "alert");
                return;
            }
            this.$api.setPCPassword(this.pc).then((result) => {
                if (result) {
                    this.$root.toast(this.$t(PC_MESSAGES.SAVED), "success");
                    this.pc.is_protected = 1;
                    this.hasCustomPassword = true;
                    this.originalCustomPassword = this.pc.custom_password;
                    window.location.reload();
                } else {

                    Object.keys(result).forEach(key => {

                        this.$root.toast(key + ":" + result[key], "alert");
                    });
                }
            });


        },

        removeCustomPw() {
            const dialogID = `remove-custom-password-${this.pc.id}-${Date.now()}`;

            this.$root.$once(dialogID, async confirmed => {
                if (!confirmed) return;

                const result = await this.$api.removePCPassword(this.pc);
                if (result) {
                    this.pc.custom_password = "";
                    this.pc.custom_password2 = "";
                    this.pc.is_protected = 0;
                    this.hasCustomPassword = false;
                    this.originalCustomPassword = "";
                    this.$root.toast(this.$t(PC_MESSAGES.PASSWORD_REMOVED), "success");
                    window.location.reload();
                }
            });

            this.$root.openYesNoDialog(
                dialogID,
                this.$t("Remove custom password"),
                this.$t("Are you sure you want to remove the custom password?"),
                this.$t("Remove"),
                this.$t("Close"),
                "js-dialog-close alert",
                "js-dialog-close button"
            );
        },

        sendInstallMessage(idupdate) {

            var dialogID = Math.floor(100000 + Math.random() * 900000).toString();
            let self = this;
            this.$root.$on(dialogID, ok => {
                self.$root.$off(dialogID);

                if (!ok) {
                    self.$router.removeHash(); // prototype implementato in main.js
                    return;
                }

                self.$root.socket("installwinupdate", idupdate)
                    .then((res) => {
                        //NON SO SE MI RITORNA QUALCOSA
                        //self.$root.toast(this.$t(PC_MESSAGES.LICENSE_REMOVED), "success");
                        self.$router.removeHash(); // prototype implementato in main.js
                    });
            });

            this.$root.openYesNoDialog(dialogID, this.$t("Install"), this.$t("Are you sure to install \"{0}\"?", { 0: this.patches[idupdate].title }));
        },


        /***************************************PROCESSI******************************************************************/


        runApp() {
            var self = this;
            self.$root.socket("runprocess", self.runAppPath);
        },
        async killApp(pid) {
            let self = this;
            var dialogID = Math.floor(100000 + Math.random() * 900000).toString();

            this.$root.$on(dialogID, (kill) => {
                if (kill)
                    self.$root.socket("killprocess", pid + "");
                self.$router.removeHash(); // prototype implementato in main.js
                self.$root.$off(dialogID);
            })

            this.$root.openYesNoDialog(dialogID, this.$t("Kill process"), "Are you sure to kill this process?");

        },

        /*************************************FILESYSTEM******************************************************************/


        //Chiude la finestre di restore
        reset() {

            this.type_number = -1;
            this.restoreType = -1

            this.selectedindex = -1;

            //this.$root.$emit("closeFileSystemSidebar");
        },



        openDeleteItemDialog(path, type) {
            var node = new ClientTreeNode(null, null, path, type);
            this.$root.$emit("OPENDELETEITEMDIALOG", node);
        },
        /************************************BACKUP************************************************************************/
        /*async logJob(idBackup) {
            let self = this;
            self.backupJobLogs = await this.$api.getBackupLogs(idBackup);
            if (self.backupJobLogs.length != 0)
                window.Metro.charms.toggle("#log");
        },*/
        async getLog(log, index) {
            let self = this;
            if (index == self.selectedIndex) {
                self.backupJobLogs[self.selectedIndex].partial_log = null;
                self.selectedIndex = -1;
                return;
            }
            if (self.selectedIndex != -1) {
                self.backupJobLogs[self.selectedIndex].partial_log = null;
            }
            self.selectedIndex = index;
            self.backupJobLogs[self.selectedIndex].partial_log = await this.$root.socket("GetHTMLBackupLog", log.logfile_name);
        },

        async jobAction(action, job) {
            switch (action) {

                case 'see':
                    this.backupIDForView = job.id;
                    this.openBackupView(job.id);
                    break;
                case 'edit':
                    this.$router.push(this.$route.path + '/backup/' + job.id);
                    break;
            }
        },

        async restoreAction(action, resId) {
            switch (action) {
                case 'stop':
                    this.$root.socket("STOPRESTORE", resId);
                    break;
                case 'delete':
                    this.deleteRestore(resId);
                    break;
            }
        },
        async deleteRestore(resId) {
            let self = this;
            var dialogID = Math.floor(100000 + Math.random() * 900000).toString();

            this.$root.$on(dialogID, async ok => {
                try {
                    if (!ok) {
                        return;
                    }

                    ok = await self.$root.socket("DELETERESTORE", resId);
                    if (!ok) {
                        return;
                    }

                    delete self.restores[resId];

                } finally {
                    self.$router.removeHash(); // prototype implementato in main.js
                    self.$root.$off(dialogID);
                }
            });

            this.$root.openYesNoDialog(dialogID, this.$t("Delete restore"), this.$t("Are you sure to delete restore \"{0}\"?", { 0: self.restores[resId].restorename }));

        },
        /******************************************BOTTONI*********************************/
        runJob(job) {
            let self = this;
            this.$root.$on("runJob_feedback", feedback => {

                if (feedback.status == self.$ResultValue.OK) {
                    //self.job.isRunning= "R";
                }


                if (feedback.status == self.$ResultValue.Error) {
                    //self.job.isRunning= "NR";
                }

                if (feedback.status != self.$ResultValue.Running) {
                    self.$root.$off("runJob_feedback");
                    return;
                }

            });

            this.$root.$emit("runJob", job);
        },
        pauseJob(job) {
            let self = this;
            this.$root.$on("pauseJob_feedback", feedback => {

                if (feedback.status == self.$ResultValue.OK) {
                    job.isRunning = "NR";
                }


                if (feedback.status == self.$ResultValue.Error) {
                    job.isRunning = "R";
                }

                if (feedback.status != self.$ResultValue.Running) {
                    self.$root.$off("pauseJob_feedback");
                    return;
                }

            });

            this.$root.$emit("pauseJob", job);
        },


        editJob(job) {
            this.$router.push("/computers/computer/" + this.idPC + "/backup/" + job.id);
            this.$root.$emit("CLOSEBACKUPVIEW");
        },
        /*renameJob() {
            this.$root.$emit("OPENRENAMEJOBDIALOG", this.job.id, this.job.name);
        },*/

        configureRestoreJob(job) {

            // let self=this;
            // this.$root.$on("restoreJob_feedback", feedback => {

            //     if (feedback.status==self.$ResultValue.OK) {
            //         this.$root.$emit("CLOSEBACKUPVIEW");
            //     }

            //     if (feedback.status!=self.$ResultValue.Running) {
            //         self.$root.$off("restoreJob_feedback");
            //         return;
            //     }

            // });

            this.$root.$emit("configureRestoreJob", job);

        },


        deleteJob(job) {

            let self = this;
            this.$root.$on("deleteJob_feedback", feedback => {

                if (feedback.status == self.$ResultValue.OK) {
                    this.$root.$emit("CLOSEBACKUPVIEW");
                }

                if (feedback.status != self.$ResultValue.Running) {
                    self.$root.$off("deleteJob_feedback");
                    return;
                }

            });

            this.$root.$emit("deleteJob", job);

        },

        filteredList(data) {
            this.filtered_socket_backups = this.socket_backups;
            this.filtered_socket_backups = this.socket_backups.filter((backup) => {
                return backup.name.toLowerCase().includes(data.toLowerCase())
            });
        },

        /**************************SIGNALR CALLBACKS***********************************************************************/


        /******************************************UTILS*****************************************************************/

        secondsToFormattedString(string) {
            return secondsToFormattedString(string);
        },


        fromNow(date) {
            if (date == null || date == "") return ""
            return fromNow(date, this.$moment);
        },

        openBackupView(idBackup) {
            this.idBackupInView = idBackup;
            this.$root.$emit("OPENBACKUPVIEW", idBackup);
        },

        diffDate(datestart, dateend) {
            return diffDate(datestart, dateend, this.$moment);
        },



        orderJobs(a, b) {
            var start_a = a.dt_start_utc == null || a.dt_start_utc == "" ? "00000000000000" : a.dt_start_utc;
            var start_b = b.dt_start_utc == null || b.dt_start_utc == "" ? "00000000000000" : b.dt_start_utc;
            //Do precedenza ai backup mai avviati
            if (start_a == null)
                return 1;
            if (start_b == null)
                return 1;

            return start_a > start_b ?
                -1 :
                start_a == start_b ?
                    0 :
                    1;
            //Ordino i backup da quelli che sono stati avviati recentemente a quelli avviati tempo fa
            //Secondo la documentazione : https://learn.microsoft.com/it-it/dotnet/api/system.datetime.compareto?view=net-7.0
            //CompareTo ritorna :
            // - -1 se a è stato avviato prima di b
            // - 1 se b è stato avviato prima di a
            //Volendo ordinare i job dal più recente al meno recente, aggiungo il segno meno al risultato di CompareTo
            //var x = -start_a.CompareTo(start_b);
            //return x;

        },





        jobs_orderBy(orderByFunction) {
            var [ordered_map, _] = orderByFunction(Object.values(this.socket_backups), "YYYYMMDDHHmmss");
            this.socket_backups = {};
            this.socket_backups = ordered_map;
        },

        patches_orderBy(orderByFunction) {
            var [ordered_map,] = orderByFunction(Object.values(this.patches), "YYYY-MM-DDTHH:mm:ss");
            this.patches = {};
            this.patches = ordered_map;
        },


        exportInCSV(list) {
            var fileName = "IONE_SW_LIST_" + this.pc.name + "_" + this.$moment(new Date()).format('YYYYMMDDHHmm') + ".csv";
            exportListInCSVFile(list, fileName);
        }

    }
}
